import { createAction } from 'redux-actions';
import { instance } from "../../../config/interceptor";

export const cleanupAction = createAction('CLEANUP_UPDATE_CLASSIFICATION');

export const cleanup = ()  => async (dispatch) => {
  dispatch(cleanupAction());
}

export const updateClassificationRequest = createAction('UPDATE_CLASSIFICATION_REQUEST');
export const updateClassificationSuccess = createAction('UPDATE_CLASSIFICATION_SUCCESS');
export const updateClassificationError = createAction('UPDATE_CLASSIFICATION_ERROR');

export const updateClassification = (data) => async (dispatch) => {
  try {
    dispatch(updateClassificationRequest());
    
    const resp = await instance.put(`/v1/Classification/Put`, data);

    dispatch(updateClassificationSuccess(resp.data));
  } catch (e) {
    if(e.response && e.response.data && e.response.data.description)
      dispatch(updateClassificationError(e.response.data.description));
    else
      dispatch(updateClassificationError(e.message));
  }
};
